export default __webpack_public_path__ + "static/media/ComparisonLightActive.33e4f8b8.svg";